var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVtmsRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 430.367,
    height: 336.975,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2148.02 1681.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0,.fil1,.fil2{fill:#fefefe}.fil0,.fil2{fill-rule:nonzero}.fil0{fill:#1c92c7}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1496.58v1681.88H0z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.33 69.65h1358.53v1542.59H69.33z",
    className: "fil1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.03 113.47h1269v1454.94h-1269z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2147.22 1375.59H1069.16V306.3h1078.06z",
    className: "fil2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1936.87 735.77h-666.12V516.65h666.12zM1936.87 1165.24h-666.12V946.12h666.12z",
    className: "fil2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.16 306.3h1078.86v1069.29H1069.16z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.98 350.52h990.41v981.24h-990.41z",
    className: "fil1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.92 946.12h664.66v219.12h-664.66z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.34 998.71h561.83v113.94h-561.83z",
    className: "fil1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.92 516.65h664.66v219.12h-664.66z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.34 569.24h561.83v113.94h-561.83z",
    className: "fil1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.67,
    cy: 1200.62,
    r: 110.89,
    className: "fil1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1393476927824"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.25 1089.73c61.24 0 110.89 49.65 110.89 110.89s-49.65 110.89-110.89 110.89-110.89-49.65-110.89-110.89 49.65-110.89 110.89-110.89z",
    className: "fil1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549.8 1532.37-136.55.13-136.55-.13-6.7-.63-7.33-1.26-8.34-2.53-9.74-4.43-7.84-5.18-6.7-5.82-6.45-6.95-5.82-9.35-3.41-7.59-3.67-11.76-1.14-10.24.25-14.66.51-17.7.88-15.3 1.64-12.52 1.64-9.86 3.04-13.15 3.16-14.16 4.04-11 4.42-11 6.32-11.88 5.69-8.98 8.09-9.74 8.6-7.71 8.34-5.69 6.83-3.79 10.87-4.17 9.73-2.02 9.1-1.14 7.33.38 4.3 1.64 5.31 3.16 10.11 6.83 12.01 7.84 13.15 7.46 15.17 6.19 16.82 5.18s0-.13 11.63 1.64l14.67.25 14.68-.25c11.63-1.77 11.63-1.64 11.63-1.64l16.82-5.18 15.17-6.19 13.15-7.46 12.01-7.84 10.11-6.83 5.31-3.16 4.3-1.64 7.33-.38 9.1 1.14 9.74 2.02 10.87 4.17 6.83 3.79 8.35 5.69 1.83 1.64-6.76 6.07-8.09 9.74-5.69 8.98-6.32 11.88-4.42 11-4.04 11-3.16 14.16-3.04 13.15-1.64 9.86-1.64 12.52-.88 15.3-.51 17.7-.25 14.66 1.14 10.24 3.67 11.76 3.41 7.59 5.82 9.35 6.45 6.95 6.7 5.82 7.84 5.18 9.74 4.43 1.71.52-6.64 2.01-7.33 1.26-6.7.63z",
    className: "fil1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m886.22 1532.37-136.55.13-136.55-.13-6.7-.63-7.33-1.26-8.35-2.53-9.73-4.42-7.84-5.18-6.7-5.82-6.45-6.95-5.82-9.35-3.41-7.59-3.67-11.76-1.14-10.24.25-14.66.51-17.7.88-15.3 1.64-12.52 1.64-9.86 3.03-13.15 3.16-14.16 4.04-11 4.43-11 6.32-11.88 5.69-8.98 8.09-9.73 8.6-7.71 8.34-5.69 6.83-3.79 10.87-4.17 9.73-2.02 9.1-1.14 7.33.38 4.3 1.64 5.31 3.16 10.11 6.83 12.01 7.84 13.15 7.46 15.17 6.19 16.81 5.18s0-.13 11.63 1.64l14.67.25 14.68-.25c11.63-1.77 11.63-1.64 11.63-1.64l16.81-5.18 15.17-6.19 13.15-7.46 12.01-7.84 10.11-6.83 5.31-3.16 4.3-1.64 7.33-.38 9.1 1.14 9.74 2.02 10.87 4.17 6.83 3.79 8.34 5.69 8.6 7.71 8.09 9.73 5.69 8.98 6.32 11.88 4.43 11 4.04 11 3.16 14.16 3.03 13.15 1.64 9.86 1.64 12.52.88 15.3.51 17.7.25 14.66-1.14 10.24-3.67 11.76-3.41 7.59-5.82 9.35-6.45 6.95-6.7 5.82-7.84 5.18-9.74 4.42-8.34 2.53-7.33 1.26-6.7.63z",
    className: "fil1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtmsRight);
export default __webpack_public_path__ + "static/media/vtms_right.7add9a4b87af2e492681846f563ae44f.svg";
export { ForwardRef as ReactComponent };